import HotplaceDetailActions from '@/components/feature/list-type/hotplace/hotplace-detail-actions';
import { useOrientation } from '@/hooks/useOrientation';
import { useConfigStore } from '@/stores';
import type { ListTypeListItem } from '@/types/list-type';
import { getS3UploadUrl, isS3UploadUrl } from '@/utils/s3Config';
import clsx from 'clsx';
import HotplaceContent from './hotplace-content';
import HotplaceImage from './hotplace-image';
import styles from './styles.module.scss';

interface HotplaceDetailPanelProps {
    item: ListTypeListItem;
    onLocationClick: () => void;
    onDirectionClick: () => void;
}

const HotplaceDetailPanel = ({ item, onLocationClick, onDirectionClick }: HotplaceDetailPanelProps) => {
    const { isHorizontal } = useOrientation();
    const screenMode = useConfigStore((s) => s.config?.ui?.screenMode);

    const title = item.title || '';
    const body = item.contents || '';
    const url = item?.contentsUrl?.url;
    const urlPreview: string | null | undefined = url ? (isS3UploadUrl(url) ? url : getS3UploadUrl(url)) : '';

    const showPoiActions = !!item.poiConnect;
    const isVerticalHalfMode = !isHorizontal && screenMode === 'split';

    const panelClassName = clsx(styles.panel, {
        [styles['panel--horizontal']]: isHorizontal,
        [styles['panel--vertical']]: !isHorizontal,
        [styles['panel--halfmode']]: screenMode === 'split',
    });

    if (isVerticalHalfMode) {
        return (
            <div className={panelClassName}>
                <div className={clsx(styles['panel__scroll-area'], 'scrollbar-custom-gray-99938f scrollbar-w-6')}>
                    <HotplaceImage title={title} urlPreview={urlPreview} />
                    <HotplaceContent
                        title={title}
                        body={body}
                        showPoiActions={showPoiActions}
                        showActionsInline={false}
                        onLocationClick={onLocationClick}
                        onDirectionClick={onDirectionClick}
                    />
                </div>
                {showPoiActions && (
                    <div className={styles['panel__actions']}>
                        <HotplaceDetailActions onLocationClick={onLocationClick} onDirectionClick={onDirectionClick} />
                    </div>
                )}
            </div>
        );
    }

    return (
        <div className={panelClassName}>
            <HotplaceImage title={title} urlPreview={urlPreview} />
            <HotplaceContent
                title={title}
                body={body}
                showPoiActions={showPoiActions}
                showActionsInline={true}
                onLocationClick={onLocationClick}
                onDirectionClick={onDirectionClick}
            />
        </div>
    );
};

export default HotplaceDetailPanel;
